const respondToMainCtaVisibility = function (element, callback) {
  const options = {
    rootMargin: '0px',
    threshold: 1,
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      callback(entry.intersectionRatio > 1 || entry.isIntersecting);
    });
  }, options);

  observer.observe(element);
};

const toggleStickyCtaVisibility = (isMainCtaVisible) => {
  const stickyCtaContainer = document.querySelector('.sticky-cta-container');

  if (stickyCtaContainer !== null) {
    if (isMainCtaVisible) {
      stickyCtaContainer.classList.add('!tw-hidden');
    } else {
      stickyCtaContainer.classList.remove('!tw-hidden');
    }
  }
};

/**
 * Formats a price in cents to a money string
 * @param {number} cents - Price in cents
 * @returns {string} - Formatted price string
 */
const formatMoney = (cents) => {
  if (typeof cents !== 'number') {
    return '';
  }

  const moneyFormat = window.stickyCartMoneyFormat || '{{amount}}';
  const value = (cents / 100).toFixed(2);

  return moneyFormat.replace('{{amount}}', value);
};

/**
 * Updates the sticky cart prices when variant changes
 * @param {Object} variant - The selected variant object
 */
const updateStickyPrices = (variant) => {
  if (!variant) return;

  const compareAtPriceElement = document.querySelector('[data-sticky-compare-price]');
  const priceElement = document.querySelector('[data-sticky-price]');

  if (!priceElement) return;

  priceElement.textContent = formatMoney(variant.price);

  if (compareAtPriceElement) {
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      compareAtPriceElement.textContent = formatMoney(variant.compare_at_price);
      compareAtPriceElement.style.display = '';
    } else {
      compareAtPriceElement.style.display = 'none';
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const mainCtaNode = document.querySelector('.goshop-product-cta-visibility');

  respondToMainCtaVisibility(mainCtaNode, toggleStickyCtaVisibility);

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event?.data?.variant) {
        updateStickyPrices(event.data.variant);
      }
    });
  }
});
